const ENCRYPTED_KEY = "5xazq*tnffk7BHdjcl";
// import {enc, SHA256, AES} from "crypto-js";

export const encryptAES = async (input: string, key = "5xazq*tnffk7BHdjcl") => {
  const SHA256 = (await import('crypto-js')).SHA256;
  const enc = (await import('crypto-js')).enc;
  const AES = (await import('crypto-js')).AES;
  const input_byteArray = toByteArray(input);
  const key_byteArray = toByteArray(key);
  const key_hex = bytesToHex(key_byteArray);
  const key_wordArray = enc.Hex.parse(key_hex);
  const key_hashed = SHA256(key_wordArray);

  const iv = Math.floor(1000000000000000 + Math.random() * 9000000000000000); // Generate a random number with 16 digit length
  const iv_byteArray = toByteArray(iv.toString());
  const iv_hex = bytesToHex(iv_byteArray);
  const iv_wordArray = enc.Hex.parse(iv_hex);

  const destination = iv_byteArray.concat(input_byteArray);
  const destination_hex = bytesToHex(destination);
  const destination_wordArray = enc.Hex.parse(destination_hex);

  const encryptedCP = AES.encrypt(destination_wordArray, key_hashed, {
    iv: iv_wordArray
  });
  return encryptedCP.toString();
};

// Convert string (UTF-8) to a byte array
const toByteArray = (str: string) => {
  let bytes: any[] = [];
  for (let i = 0; i < str.length; ++i) {
    let code = str.charCodeAt(i);
    bytes = bytes.concat([code]);
  }
  return bytes;
};

// Convert a hex string to a byte array
const hexToBytes = (hex: any) => {
  for (var bytes = [], c = 0; c < hex.length; c += 2)
    bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
};

// Convert a byte array to a hex string
const bytesToHex = (bytes: any) => {
  for (var hex = [], i = 0; i < bytes.length; i++) {
    var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
    hex.push((current >>> 4).toString(16));
    hex.push((current & 0xf).toString(16));
  }
  return hex.join("");
};

export const randomNumber = (min: number, max: number) => { 
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
} 